import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AboutSection() {
    const { t } = useTranslation();

    return (
        <>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[30px]">
                    <div className="flex flex-col items-center justify-center gap-[8px] text-center">
                        <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
                            {t("About us")}
                        </h2>
                        <div className="flex flex-col gap-[3px] justify-center items-center">
                            <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
                            <span className="bg-[#3896BE] flex w-[250px] h-[4px]"></span>
                            <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
                        </div>
                    </div>

                    <div className="f-col g-20-res flex items-center">
                        <div className="w-100 w-[49%] flex flex-col gap-[30px]">
                            <div className="flex flex-col gap-[10px]">
                                <div className="text-[30px] font-bold">
                                    {t("MA Partners Chartered Accountants")}
                                </div>
                                <p>
                                    {t(`MA Partners Chartered Accountants is a fast-growing
                  professional services firm based in Abu Dhabi, United Arab
                  Emirates. We offer a variety of professional services to our
                  clients and we adapt to their requirements and needs. We
                  become part of your business. Our main concern is your
                  business always.Our knowledgeable, experienced and
                  professional people are working for you and their objective is
                  to achieve the best for you. Through our close relationship
                  and the high quality services offered, your objectives,
                  strategy, mission and vision are achieved.`)}
                                </p>
                            </div>
                            <Link
                                to={"/about-us"}
                                className="w-fit px-[30px] py-2 rounded text-white font-bold bg-[#3896BE]"
                            >
                                {t("Explore More")}
                            </Link>
                        </div>
                        <div className="w-100 w-[49%]">
                            <img
                                src={require("../../assets/images/about-home.svg").default}
                                alt=""
                                className="w-full h-[80%]"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
